import { render, staticRenderFns } from "./AboutStructure.vue?vue&type=template&id=d0b3a55e&"
import script from "./AboutStructure.vue?vue&type=script&lang=js&"
export * from "./AboutStructure.vue?vue&type=script&lang=js&"
import style0 from "./AboutStructure.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports